import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { remove, findByCodTurmaAndCodCronogramaData, findByCodTurmaAndCodCronogramaDataVersao2 } from './api-cronograma';
import { timeFormat, dayOfWeekName } from '../../util/DateUtil';
import 'react-toastify/dist/ReactToastify.css';
import Button from '@mui/material/Button';
import { useSelector, useDispatch } from 'react-redux';
import { setCronogramas, setCronograma, removeCronogramas } from "./actions/actions";
import { setCronogramaAula } from './Aula/actions/actions';
import Loading from '../UI/Loading';
import { errorMessage } from '../../util/ConfirmAlertUtil';
import { Grid } from '@mui/material';
import CronogramaTableV2 from './CronogramaTableV2';


const useStyles = makeStyles({

    table: {
        minWidth: 650,
    },
    novoRegistro: {
        marginBottom: '30px'
    },
    cursorLink: {
        cursor: 'pointer'
    },
    mediaPrintElement: {
        '@media print': {
            display: 'none'
        }
    }
});


export default function CronogramaTable({ cronogramaData, handleOpenCronogramaTableSelect, versao2 }) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const cronogramas = useSelector(state => state.cronogramas);
    const turma = useSelector(state => state.turma);
    const [isLoading, setIsLoading] = useState(true);
    const [listCronogramasReport, setListCronogramasReport] = useState([]);

    useEffect(() => {
        if (turma && !versao2) {
            setIsLoading(true);
            findByCodTurmaAndCodCronogramaData(turma.codigo, cronogramaData.codigo).then((data) => {
                if (data) {
                    if (data.error) {
                        errorMessage(data.error);
                    } else {
                        dispatch(setCronogramas(data));
                    }
                }
                setIsLoading(false);
            })
        }
        else if (turma && versao2) {
            setIsLoading(true);
            findByCodTurmaAndCodCronogramaDataVersao2(turma.codigo, cronogramaData.codigo).then((data) => {
                if (data) {
                    if (data.error) {
                        errorMessage(data.error);
                    } else {
                        setListCronogramasReport(data);
                    }
                }
                setIsLoading(false);
            })
        }
    }, [turma, cronogramaData, dispatch, versao2]);





    const handleDelete = (index) => {
        confirmAlert({
            title: 'Alerta',
            message: 'Deseja deletar este Cronograma?',
            buttons: [
                {
                    label: 'Sim',
                    onClick: () => {
                        remove(cronogramas[index].codigo).then((data) => {
                            if (data) {
                                if (data.error) {
                                    errorMessage(data.message);
                                } else {
                                    dispatch(removeCronogramas(cronogramas[index].codigo));
                                }
                            }
                        });
                    }
                },
                {
                    label: 'Não',
                    onClick: () => { }
                }
            ]
        });
    };

    const handleAdicionarCronograma = () => {
        dispatch(setCronograma({
            tdp: {
                turma: turma,
            },

            eNovo: true
        }));
        dispatch(setCronogramaAula(null));
    }


    return (
        <>
            {versao2 ?
                <>
                    {isLoading ?
                        <Loading description="Carregando Cronograma..." />
                        :
                        <CronogramaTableV2 cronogramas={listCronogramasReport} />
                    }

                </> :
                <Grid container direction='column' spacing={3}>
                    <Grid className={classes.mediaPrintElement}>
                        <Grid container direction='row' spacing={3}>
                            <Grid>
                                <Button
                                    onClick={handleAdicionarCronograma}
                                    variant="contained"
                                    color="primary">
                                    Adicionar Cronograma
                                </Button>
                            </Grid>
                            <Grid>
                                <Button
                                    onClick={handleOpenCronogramaTableSelect}
                                    variant="contained"
                                    color="primary">
                                    Copiar Último Cronograma Data por Cronograma Aula
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid>
                        {isLoading ?
                            <Loading description="Carregando Cronograma..." />
                            :
                            <Table size="small" aria-label="a dense table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Dia Semana</TableCell>
                                        <TableCell>Ordem Aula</TableCell>
                                        <TableCell>Horário</TableCell>
                                        <TableCell>Disciplina</TableCell>
                                        <TableCell>Professor</TableCell>
                                        <TableCell>Local</TableCell>
                                        <TableCell className={classes.mediaPrintElement}>Ações</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {cronogramas.map((c, index) => (
                                        <TableRow key={c.codigo}>
                                            <TableCell>{dayOfWeekName(c.diaSemana)}</TableCell>
                                            <TableCell>{c.cronogramaAula.ordemAula}</TableCell>
                                            <TableCell>{timeFormat(c.cronogramaAula.horarioInicio)} - {timeFormat(c.cronogramaAula.horarioFim)}</TableCell>
                                            <TableCell>{c.tdp.disciplina.descricao}</TableCell>
                                            <TableCell>{c.tdp.usuario ? c.tdp.usuario.nome : '--'}</TableCell>
                                            <TableCell>{c.local ? c.local.descricao : '--'}</TableCell>
                                            <TableCell className={classes.mediaPrintElement}>
                                                <EditIcon
                                                    className={classes.cursorLink}
                                                    fontSize='small'
                                                    onClick={() => {
                                                        dispatch(setCronograma(c));
                                                        dispatch(setCronogramaAula(null));
                                                    }}
                                                    color="secondary"
                                                    style={{ marginRight: '10px' }} />
                                                <DeleteIcon
                                                    className={classes.cursorLink}
                                                    fontSize='small'
                                                    onClick={() => { handleDelete(index) }} color="secondary" />
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>

                        }
                    </Grid>
                </Grid >
            }
        </>
    );
}